import { Link, useNavigate } from "react-router-dom";
import { Button, Divider, Form, Input, InputNumber, Row } from "antd";
import Col from "antd/lib/grid/col";
import Servico from "../../../Models/Financeiro/Faturamento/Servico";
import ServicoTable from "../../../Components/Populados/Financeiro/Faturamento/Servico/ServicoTable";
import { useEffect } from "react";
import { FormItemAntDChangeInBlur } from "../../../Components/Formularios/Base/FormItemAntDChangeInBlur";
import ComponentePermissao from "../../../Components/Base/Permissao/ComponentePermissao";
import { PermissoesKey } from "../../../Constants/Permissoes";

export default function Consulta() {
    const navigate = useNavigate();
    const [formulario] = Form.useForm<Servico>();
    const servicos = Form.useWatch([], formulario);

    return <Form
        layout="vertical"
        autoComplete="off"
        form={formulario}
    >
        <Row gutter={8} wrap>
            <Col xs={18}>
                <Form.Item<Servico> name={"nome"} label={"Nome"}>
                    <FormItemAntDChangeInBlur>
                        <Input placeholder="Nome" />
                    </FormItemAntDChangeInBlur>
                </Form.Item>
            </Col>
            <Col xs={6}>
                <Form.Item<Servico> name={"codigoServico"} label={"Código do serviço"} >
                    <InputNumber style={{ width : "100%" }} onChange={undefined} controls={false} placeholder="Código do serviço" />
                </Form.Item>
            </Col>
            <ComponentePermissao permissoes={["FinanceiroFaturamentoServicoInserir"]}>
                <Col xs={"auto"}>
                    <Link to={"../adicionar"}>
                        <Button type="primary" style={{ width: "100%" }}>
                            Adicionar
                        </Button>
                    </Link>
                </Col>
            </ComponentePermissao>
            <Col xs={24}>
                <Divider />
            </Col>
            <ComponentePermissao permissoes={["FinanceiroFaturamentoServicoListar"]}>
                <Col xs={24}>
                    <ServicoTable 
                        onEditar={({codigo}) => {
                            navigate(`../alterar/${codigo}`)
                        }}
                        filtros={{
                            servico : servicos
                        }} 
                    />
                </Col>
            </ComponentePermissao>
        </Row>
    </Form>;
}